<template>
    <div style="width:100%" ref="parent">
        <canvas id="video" ref="body" />
    </div>
</template>

<script>
    import JSMpeg from '@/vue-jsmpeg.js'
    export default {
        props: {
            url: {
                type: String,
                default: null
            }
        },
        data: function () {
            return {
                player: null
            }
        },
        mounted: function () {
            var canvas = document.getElementById("video")
            console.log("canvas", canvas)
            // var player = new JSMpeg.Player("ws://192.168.1.4:9999", 
            //     {
            //         canvas: canvas,
            //         autoplay: true
            //     }
            // )
            this.player = new JSMpeg.Player(
                this.url, 
                {
                    canvas: canvas,
                    autoplay: true
                }
            )
        },
        beforeDestroy: function () {
            console.log("beforeDestroy")
            this.player.destroy()
        }
    }
</script>
